<div>
  <p>
    This website uses cookies to ensure you get the best experience. If you do
    not agree with the use of cookies, please close this window or tab. <br />
    <a href="{{ identityUrl }}/Shared/CookiePolicy" target="_blank">Read More</a>
  </p>
</div>
<button
  type="button"
  class="btn btn-outline-primary btn-block"
  (click)="onClose()"
>
  Continue
</button>
